export const validRegistrationPhone = value => /^\+?[0-9 ().-]+$/.test(value.trim()) && /^[0-9]{7,15}$/.test(value.replace(/[^0-9]/g, ''));
export const PHONE_TEXT = {
  en: {required: 'required', error: 'Enter your phone number (7–15 digits).'},
  de: {required: 'Pflichtfeld', error: 'Geben Sie Ihre Telefonnummer ein (7–15 Ziffern).'},
  sv: {required: 'obligatoriskt', error: 'Ange ditt telefonnummer (7–15 siffror).'},
  da: {required: 'påkrævet', error: 'Indtast dit telefonnummer (7–15 cifre).'},
  fr: {required: 'obligatoire', error: 'Saisissez votre numéro de téléphone (7 à 15 chiffres).'},
  nl: {required: 'verplicht', error: 'Voer uw telefoonnummer in (7–15 cijfers).'},
  no: {required: 'obligatorisk', error: 'Skriv inn telefonnummeret ditt (7–15 sifre).'},
};
